import { gql, useQuery } from "@apollo/client";

export const GET_ONBOARDING_DOCUMENTS = gql`
    query GetOnboardingDocuments($channelId: Long!) {
        getOnboardingDocuments(channelId: $channelId) {
            objectKey
            filename
            fileSize
            uploadedAt
        }
    }
`;

export interface OnboardingDocument {
    objectKey: string;
    filename: string;
    fileSize: number;
    uploadedAt: string;
}

export interface GetOnboardingDocumentsResponse {
    getOnboardingDocuments: OnboardingDocument[];
}

export interface GetOnboardingDocumentsVariables {
    channelId: number;
}

export const useOnboardingDocuments = (channelId: number | null) => {
    return useQuery<GetOnboardingDocumentsResponse, GetOnboardingDocumentsVariables>(
        GET_ONBOARDING_DOCUMENTS,
        {
            variables: { channelId: channelId! },
            skip: !channelId,
            fetchPolicy: 'network-only' // 每次都从服务器获取最新数据
        }
    );
};

